document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-video]')
  if (!sections.length) return

  sections.forEach((section) => {
    const toggle = section.querySelector('[data-video-toggle]')
    const videos = section.querySelectorAll('[data-video-item]')
    const pauseIcon = section.querySelector('[data-video-icon="pause"]')
    const playIcon = section.querySelector('[data-video-icon="play"]')

    // Play/pause toggle
    if (toggle && videos.length) {
      let isPlaying = true

      const visibleVideos = () => [...videos].filter((video) => video.getClientRects().length > 0)

      const updateToggle = () => {
        pauseIcon?.classList.toggle('hidden', !isPlaying)
        playIcon?.classList.toggle('hidden', isPlaying)
        toggle.setAttribute('aria-label', isPlaying ? toggle.dataset.pauseLabel : toggle.dataset.playLabel)
      }

      toggle.addEventListener('click', () => {
        const targets = visibleVideos().length ? visibleVideos() : [...videos]

        isPlaying = !isPlaying
        targets.forEach((video) => {
          if (isPlaying) video.play()?.catch(() => {})
          else video.pause()
        })
        updateToggle()
      })

      updateToggle()
    }

    window.initVideoSoundToggle?.(section, '[data-video-item]')

    // On load animation
    if (!window.gsap) return

    const { gsap } = window
    const controls = section.querySelector('[data-video-controls]')

    gsap.set(section, { autoAlpha: 0 })
    if (controls) gsap.set(controls, { y: 16, opacity: 0 })

    const tl = gsap.timeline({ delay: 0.6 })
    tl.to(section, { autoAlpha: 1, duration: 2.4, ease: 'power2.out' }, 0)

    if (controls) {
      tl.to(controls, { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' }, 0.8)
    }
  })
})
